import { useContext } from "react"
import { TooltipContext } from "./TooltipContext"

export const useTooltipContext = () => {
	const context = useContext(TooltipContext)

	if (context == null) {
		throw new Error("useTooltipContext is called outside a TooltipContext.Provider")
	}

	return context
}
